import { Routes } from '@angular/router';

import { TargetingResultsComponent } from '../../Targeting/components/TargetingResults/targeting-results.component';
import { PortfolioHypeComponent } from '../../Targeting/components/Portfolios/PortfolioHype/portfolio-hype.component';


export const portfolioRoutes: Routes = [
    {
        path: '',
        component: PortfolioHypeComponent,
        data: {title: 'Discover.industryLists.browserTitle'}
    },
    {
        path: 'results/:id',
        component: TargetingResultsComponent
    },
    {
        path: '**',
        redirectTo: '/Discover/portfolios'
    }
];
